var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Watch } from 'vue-property-decorator';
import Modal from '@/common/components/Modal/index.vue';
import Table from '@/common/components/Table/oldIndex.vue'; // 列表组件
import { filterTime } from '@/common/utils/ways';
import { getExpirationReminder } from '../../api';
var AlertModal = /** @class */ (function (_super) {
    __extends(AlertModal, _super);
    function AlertModal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /* data */
        _this.showDialog = false;
        _this.title = '活动到期提示';
        _this.loading = false;
        // 列表相关
        _this.tableData = [];
        _this.tableColumn = [
            { prop: 'name', label: '活动名称', minWidth: 120 },
            { prop: 'boothName', label: '点位', minWidth: 120 },
            { slotName: 'startAt', label: '活动时间', minWidth: 180 },
            { slotName: 'lastDays', label: '剩余天数', minWidth: 80 },
        ];
        return _this;
    }
    Object.defineProperty(AlertModal.prototype, "storeInfo", {
        get: function () {
            return this.$store.getters['getStoreInfo'];
        },
        enumerable: false,
        configurable: true
    });
    AlertModal.prototype.shopChange = function (newVal) {
        if (newVal && newVal.length > 0) {
            this.getData();
        }
    };
    AlertModal.prototype.created = function () {
        var _this = this;
        setTimeout(function () {
            _this.getData();
        }, 500);
    };
    /* method */
    AlertModal.prototype.init = function () {
        this.showDialog = true;
    };
    AlertModal.prototype.getData = function () {
        var _this = this;
        this.loading = true;
        var params = {};
        getExpirationReminder(params).then(function (data) {
            _this.tableData = data;
            _this.$emit('load', data.length || 0);
        }).finally(function () {
            _this.loading = false;
        });
    };
    AlertModal.prototype.beforeClose = function () {
        this.showDialog = false;
        this.loading = false;
    };
    __decorate([
        Watch('storeInfo')
    ], AlertModal.prototype, "shopChange", null);
    AlertModal = __decorate([
        Component({
            components: {
                Modal: Modal,
                Table: Table,
            },
            filters: {
                filterDateFn: function (val, format) {
                    if (format === void 0) { format = 'YYYY.MM.DD'; }
                    return filterTime(val, format);
                },
            },
        })
    ], AlertModal);
    return AlertModal;
}(Vue));
export default AlertModal;
